import { KeyValue } from './types';

export const boldQuery = (string: string, query: string): string => {
  const word = string.toUpperCase();
  const subString = query.toUpperCase();
  const index = word.indexOf(subString);
  if (!subString || index === -1) {
    return string;
  }
  const length = subString.length;
  return (
    string.substr(0, index) +
    '<b>' +
    string.substr(index, length) +
    '</b>' +
    string.substr(index + length)
  );
};

export const capitalizeFirstLetter = (message: string): string =>
  message.charAt(0).toUpperCase() + message.slice(1);

type QueryString = {
  [key: string]:
    | string
    | number
    | boolean
    | KeyValue
    | (string | number | boolean | KeyValue)[];
};

export const dotNotationToHuman = (str: string): string => {
  return str
    .split('.')
    .map((piece) => camelCaseToHuman(piece))
    .join(' > ');
};

export const camelCaseToHuman = (str: string): string =>
  (str.charAt(0).toUpperCase() + str.slice(1)).split(/(?=[A-Z 0-9])/).join(' ');

export const humanToCamelCase = (str: string): string =>
  str.charAt(0).toLowerCase() + str.replace(' ', '').slice(1);

export const queryString = (params: QueryString = {}): string => {
  // get array of key value pairs ([[k1, v1], [k2, v2]])
  const qs = Object.entries(params)
    // filter pairs with undefined value
    .filter(([, value]) => value !== undefined)
    // encode keys and values, remove the value if it is null, but leave the key
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .filter((el) => el !== null)
          .map((el) => {
            if (typeof el !== 'object') {
              return `${key}=${encodeURIComponent(el)}`;
            }
            return `${key}=${encodeURIComponent(el.id)}`;
          })
          .join('&');
      }
      return [value]
        .filter((el) => el !== null)
        .map((el: string | number | boolean | KeyValue) => {
          if (typeof el !== 'object') {
            return `${key}=${encodeURIComponent(el)}`;
          }
          return `${key}=${encodeURIComponent(el.id)}`;
        })
        .join('=');
    })
    .join('&');
  return qs && `?${qs}`;
};

export const getInitials = (firstName: string, lastName?: string): string => {
  if (lastName) {
    const firstInitial = firstName.charAt(0);
    const lastInitial = lastName.charAt(0);
    return `${firstInitial.toUpperCase()}${lastInitial.toUpperCase()}`;
  }

  const formattedName = firstName.trim().split(' ');
  if (formattedName.length === 1) {
    return `${formattedName[0].charAt(0).toUpperCase()}${formattedName[0]
      .charAt(formattedName[0].length - 1)
      .toUpperCase()}`;
  }
  if (formattedName.length === 2) {
    return `${formattedName[0].charAt(0).toUpperCase()}${formattedName[1]
      .charAt(0)
      .toUpperCase()}`;
  }
  if (formattedName.length === 3) {
    return `${formattedName[0].charAt(0).toUpperCase()}${formattedName[2]
      .charAt(0)
      .toUpperCase()}`;
  }

  return `${firstName.charAt(0).toUpperCase()}${firstName
    .charAt(1)
    .toUpperCase()}`;
};

export const getPriceOrFree = (price: number, t: (key: string) => string) => {
  if (price === 0) {
    return t('commons.free');
  }
  return `${price} €`;
};
